import React from 'react';
import './App.css'
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import SideBar from './Components/SideBar';
import Home from './Pages/Home';
import Customerlist from './Pages/Customerlist';
import OrderList from './Pages/OrderList';
import OrderDetails from './Pages/OrderDetails';
import EstimateListDetails from './Pages/EstimateListDetails';
import Maincategory from './Pages/Maincategory';
import AgentList from './Pages/AgentList';
import EstimateList from './Pages/EstimateList';
import AddMaincategory from './Pages/AddMaincategory';
import AddAgent from './Pages/AddAgent';
import Products from './Pages/Products';
import AddProducts from './Pages/AddProducts';
import UpdateList from './Pages/UpdateList';
import Login from './Components/Login';
import Settings from './Components/Settings';
import Users from './Components/Users';
import Previlage from './Components/Previlage';
import Addusers from './Components/Addusers';
import Stock from './Pages/Stock';
import EditMaincategory from './Pages/EditMaincategory';
import EditAgent from './Pages/EditAgent';
import EditProducts from './Pages/EditProducts';
import EditEstimate from './Pages/EditEstimate';
import ViewCustomer from './Pages/ViewCustomer';
import Editusers from './Components/Editusers';
import Invoice from './Pages/Invoice';
import EstimateInvoice from './Pages/EstimateInvoice';
import PrintEstimateInvoice from './Pages/PrintEstimateInvoice';
import Pos from './Pages/Pos';
import EditPos from './Pages/EditPos';
import AddEstimate from './Pages/AddEstimate';
import CustomOrderList from './Pages/CustomOrderLIst';
import CustomOrderDetails from './Pages/CustomOrderDetails';
import Footer from './Components/Footer'
import PaymenyPending from './Pages/PaymenyPending';
import InvoicePrint from './Components/InvoicePrint';
import ImportProducts from './Components/ImportProducts';
import ImportCustomer from './Pages/ImportCustomer';
import AddCustomer from './Pages/AddCustomer';
import GstReport from './Pages/GstReport';
import { matchPath } from 'react-router-dom';

const AppLayout = () => {
    const location = useLocation();
    const isLoginPage = location.pathname === '/login';
    const isInvoicePage = matchPath("/invoice/:order_id", location.pathname);
     const isEstimateInvoicePage = matchPath("/estimateinvoice/:estimate_id", location.pathname);
    const isPosPage = location.pathname === "/pos"; 
    const isEditPosPage = matchPath("/editpos/:order_id", location.pathname); 
    const isAddEstimatePage = location.pathname === "/addestimate"; 
    const isEditEstimate = matchPath("/editestimate/:estimate_id", location.pathname); 
    const isInvoicePrintPage = location.pathname === "/invoiceprint";
    const isPrintEstimateInvoice = location.pathname === "/print_estimate_invoice";

    return (
        <div>
            {!isLoginPage &&!isInvoicePrintPage &&!isInvoicePage &&!isEditEstimate &&!isPrintEstimateInvoice  &&!isEstimateInvoicePage && !isPosPage && !isEditPosPage && !isAddEstimatePage  &&  <SideBar />}
            <Routes>
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="/login" element={<Login />} />
                <Route path="/home" element={<Home />} />
                <Route path="/customerlist" element={<Customerlist />} />
                <Route path="/orderlist" element={<OrderList />} />
                <Route path="/orderdetails/:order_id" element={<OrderDetails />} />
                <Route path="/estimatedetails/:estimate_id" element={<EstimateListDetails />} />
           
        
                <Route path="/maincategory" element={<Maincategory />} />
                <Route path="/agent" element={<AgentList />} />
                <Route path="/estimate" element={<EstimateList />} />
                <Route path="/editestimate/:estimate_id" element={<EditEstimate />} />
                 <Route path="/editpos/:order_id" element = {<EditPos />} />
                <Route path="/addmaincategory" element={<AddMaincategory />} />
                <Route path="/addagent" element={<AddAgent />} />
                <Route path="/products" element={<Products />} />   
                <Route path="/addproducts" element={<AddProducts />} />
                <Route path="/updateproducts" element={<UpdateList />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/users" element={<Users />} />
                <Route path="/previlage/:employee_id" element={<Previlage />} />
                <Route path="/addusers" element={<Addusers />} />
                <Route path="/editusers/:user_id" element={<Editusers />} />
                <Route path="/stock" element={<Stock />} />
                <Route path="/gstreport" element = {<GstReport />} />
                
             
               
                <Route path="/editmaincategory/:category_id" element = {<EditMaincategory />} />
              <Route path="/editagent/:agent_id" element = {<EditAgent />} />
                <Route path="/editproducts/:product_id" element = {<EditProducts />} />
                
                
             
                <Route path="/viewcustomer/:user_id" element = {<ViewCustomer />} />
                <Route path="/invoice/:order_id" element = {<Invoice />} />
                <Route path="/estimateinvoice/:estimate_id" element = {<EstimateInvoice />} />
                <Route path="/customorderlist/:user_id" element = {<CustomOrderList />} />
                <Route path="/customorderdetails/:order_id" element = {<CustomOrderDetails />} />\
                <Route path="/pos" element = {<Pos />} />
               
                <Route path="/addestimate" element = {<AddEstimate />} />
                <Route path="/paymentpending" element = {<PaymenyPending />} />
                <Route path="/invoiceprint" element = {<InvoicePrint />} />
                <Route path="/print_estimate_invoice" element = {<PrintEstimateInvoice />} />
              
                <Route path="/importproducts" element = {<ImportProducts />} />
                <Route path="/importcustomer" element = {<ImportCustomer />} />
                <Route path="/addcustomer" element = {<AddCustomer />} />
              
               
              
            </Routes>
            {!isLoginPage &&!isInvoicePrintPage &&!isInvoicePage &&!isPrintEstimateInvoice &&!isEstimateInvoicePage && !isPosPage && !isEditPosPage && !isAddEstimatePage && !isEditEstimate   &&  <Footer />}
        </div>
    );
};

const App = () => {
    return (
        <BrowserRouter >
            <AppLayout />
        </BrowserRouter>
    );
};

export default App;
